import { IJackpotRoom } from "@api/types/jackpot";
import { useLazyQuery } from "@apollo/client";
import { GET_JACKPOT_LOBBY } from "@graphql/Queries";
import { toastErrorMessage } from "@utils/utils";
import { useCallback, useState } from "react";
import useReduxState from "./useReduxState";

export function useFetchJackpotLobby(): [
  () => Promise<void>,
  // eslint-disable-next-line no-unused-vars
  (rooms: IJackpotRoom[]) => void
] {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [{ rooms }, setJackpot] = useReduxState((state) => state.jackpot);
  const [fetchJackpotLobby] = useLazyQuery(GET_JACKPOT_LOBBY, {
    onCompleted: ({ lobby: { rooms } }) => {
      toggleIsFetching(false);
      updateLobby(rooms);
    },
    onError: (e) => {
      toggleIsFetching(false);
      toastErrorMessage(e.message);
    },
  });

  const updateLobby = useCallback(
    (rooms: IJackpotRoom[]) => {
      setJackpot({
        type: "SET_JACKPOT_ROOMS",
        arg: {
          rooms,
        },
      });
    },
    [rooms]
  );

  const toggleIsFetching = useCallback(
    (state: boolean) => setIsFetching(state),
    [isFetching]
  );

  const fetchGames = useCallback(async () => {
    if (!isFetching) {
      toggleIsFetching(true);
      await fetchJackpotLobby();
    }
  }, [rooms]);

  return [fetchGames, updateLobby];
}
